<script>
    // import Spinner from "./Spinner.svelte";
    export let src;
    export let displayType; //listing, focus
    export let forceState = false;

    // forceState = "fail"

    let format = "image"; //image, video
    let state = "unloaded"; //unloaded, loaded, attemptImage, attemptVideo, fail
    let extensions = {
        video: ["mp4", "mov", "m4v",],
        image: ["jpg", "jpeg", "gif", "png", "svg", "png"]
    }

    $:{
        if (forceState) {
            state = forceState;
        } else if (src.substr(0, 7) === "ipfs://") {
            src = "https://ipfs.io/ipfs/" + src.substr(7);
        }


        if (state === "unloaded" && src) {
            let extension = (src.split(".")).pop();
            if (extension) {
                if (extensions.video.includes(extension)) {
                    format = "video";
                    state = "loaded";
                } else if (extensions.image.includes(extension)) {
                    format = "image";
                    state = "loaded";
                } else {
                    state = "attemptImage";
                }
            } else {
                state = "attemptImage";
            }
        }
    }

    function failImage() {
        // console.log('fail image');
        state = "attemptVideo";
    }

    function loadImage() {
        format = "image";
        state = "loaded";
    }

    function failVideo() {
        // console.log('fail image');
        state = "fail";
    }

    function loadVideo() {
        // console.log("video loaded");
        format = "video";
        state = "loaded";
    }

</script>


<style>
    .image {
        /*margin:5px;*/

        width: 320px;
        height: 320px;
        background: #4b5059;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .media {
        object-fit: contain;
        max-height: 320px;
        /*width: 100%;
        height: 100%;*/
    }

    .big-media {
        object-fit: contain;
        max-height: 560px;
        /*width: 100%;
        height: 100%;*/
    }

    .image-focus {
        width: 560px;
        height: 560px;
    }

    .metadata-fail {
        background: #ff5c5c;
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .image-load {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .big-text {
        font-size: 24px;
    }

    .loadVideo {
        position: absolute;
        top: 0;
        left: 0;
    }

    .bg-loaded {
        background: black;
    }
</style>

<div class="image {displayType==='focus'?'image-focus big-text':''} {['loaded','attemptVideo'].includes(state)?' bg-loaded':''}">
    {#if src === "fail"}
        <div class="metadata-fail">
            <span>UNABLE TO LOAD</span>

        </div>
    {:else}

        <!--    <div>state: {state}</div>-->
        {#if state === "initial"}
            <div class="image-load">
                <span>Enter address to load NFT data</span>
            </div>
        {:else if state === "unloaded"}
            <!--            <Spinner size="40" />-->
            <div class="image-load">
                <span>Loading...</span>
            </div>
        {:else if state === "loading"}
            <!--            <Spinner size="40" />-->
            <div class="image-load">
                <span>Loading...</span>
            </div>
        {:else if state === "loaded"}
            {#if format === "image"}
                <img class="{displayType==='focus'?'big-media':'media'}" src="{src}" alt="">
            {:else}
                <video class="{displayType==='focus'?'big-media':'media'}" autoPlay loop>
                    <!--            TODO: video type-->
                    <source src="{src}" type="video/mp4">
                </video>
            {/if}
        {:else if state === "attemptImage"}
            <!--            <Spinner size="40" />-->
            <div class="image-load">
                <span>Loading...</span>
            </div>

            <img src="{src}" on:error={failImage} on:load={loadImage} alt="" style="display: none;">
        {:else if state === "attemptVideo"}
            <!--            <Spinner size="40" />-->
            <!--            <div class="image-load">-->
            <!--                <span>Loading...</span>-->
            <!--            </div>-->
            <!---->
            <!--            <video width="300" height="300" autoplay loop style=""  on:error={failVideo} on:load={loadVideo}>-->
            <!--                &lt;!&ndash;            TODO: video type&ndash;&gt;-->
            <!--                <source src="{src}" type="video/mp4" >-->
            <!--            </video>-->

            <video class="{displayType==='focus'?'big-media':'media'}" autoplay loop style="" on:error={failVideo} on:load={loadVideo}
                   src="{src}" type="video/mp4">
            </video>

        {:else}
            <!--    Fail-->
            <div class="metadata-fail">
                <span>COULD NOT LOAD IMAGE</span>
            </div>
        {/if}
    {/if}
</div>
